import { useParams } from 'react-router'
import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import BaseScreenTable from '../../../../../../../baseComponents/TwinTable/BaseScreenTable'
import ModalCEConfigBillingTypeOption from './ModalCEConfigBillingTypeOption'
import { TableComponentProps } from '../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { BillingTypeSellOptionModelType } from '@teinor/erp/types/company/config/billingGroup/billingTypeSell/billingTypeSellOption'
import { ColumnTableSchema } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { CustomRenderString, EditRow } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import TwinTable from '../../../../../../../baseComponents/TwinTable'
import useBillingDictTypes from '../../../../../../../utils/hooks/billingGroups/useBillingDictTypes'

interface ConfigBillingTypeSellOptionsProps extends ComponentWithPermissions { }

const ConfigBillingTypeSellOptions: React.FC<ConfigBillingTypeSellOptionsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const pageData = {
        title: t('options', 'Opciones'),
        newText: t('newOption', 'Nueva opción'),
    }

    return (
        <BaseScreenTable TableComponent={TableConfigBillingTypeSellOptions} CreateModalComponent={ModalCEConfigBillingTypeOption} EditModalComponent={ModalCEConfigBillingTypeOption} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableConfigBillingTypeSellOptionsProps extends TableComponentProps { }

const TableConfigBillingTypeSellOptions: React.FC<TableConfigBillingTypeSellOptionsProps> = ({ setTableInstance, userPermissions, setOpened, tableInstance }) => {
    const { t } = useTwinTranslation()
    const { BillingTypeSellId } = useParams()
    const extraWhereParams = { 'BillingTypeSellId': BillingTypeSellId ? parseInt(BillingTypeSellId) : null }
    const { dictTypeBilling, dictExportType, dictRetentionType, dictVatSupportedType } = useBillingDictTypes()
    const columns: ColumnTableSchema<BillingTypeSellOptionModelType> = [
        {
            id: 'code',
            dataKey: 'code',
            label: t('code', 'Código'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('code', 'Código') }
            },
            width: 120
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'typeBilling',
            dataKey: 'typeBilling',
            label: t('typeBilling', 'Tipo de Factura'),
            customRender: (parameterValue) => <CustomRenderString value={dictTypeBilling[parameterValue]} />,
            hideColumnByDefault: true
        },
        {
            id: 'export',
            dataKey: 'export',
            label: t('export', 'Exportación'),
            customRender: (parameterValue) => <CustomRenderString value={dictExportType[parameterValue]} />,
            hideColumnByDefault: true
        },
        {
            id: 'retention',
            dataKey: 'retention',
            label: t('retention', 'Retención'),
            customRender: (parameterValue) => <CustomRenderString value={dictRetentionType[parameterValue]} />,
            hideColumnByDefault: true
        },
        {
            id: 'withVat',
            dataKey: 'withVat',
            label: t('withVatW', 'Con IVA'),
            customRender: (parameterValue) => <CustomRenderString value={dictVatSupportedType[parameterValue]} />,
            hideColumnByDefault: true
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />
        },
    ]
    return (
        <TwinTable columns={columns} name='configBillingTypeSellOptions' hideLoadFiltersButton={true} extraWhereParams={extraWhereParams} getDataFrom='/api/app/config/billingGroup/billingTypeSell/option/getAllBillingTypeSellOptions' setTableInstance={setTableInstance} defaultOrder={{ defaultOrderField: 'id', order: 'asc' }} />
    )

}

export default ConfigBillingTypeSellOptions